<div class="have-resume-step" [@routeAnimations]="wizardService.currentStep">
  <ng-container [ngSwitch]="wizardService.currentStep">
    <div class="animation-step">
      <bwc-upload-your-cv
        *ngSwitchCase="0"
        [openFormLink]="openFormLink"
        [inviteLink]="inviteLink"
        [vacancyId]="vacancyId"
        [source]="source"
      ></bwc-upload-your-cv>
    </div>
    <div class="animation-step">
      <bwc-uploaded-cv
        *ngSwitchCase="1"
        [openFormLink]="openFormLink"
        [inviteLink]="inviteLink"
        [vacancyId]="vacancyId"
        [source]="source"
        [prevBut]="true"
        [closeBut]="false"
      ></bwc-uploaded-cv>
    </div>
    <div class="animation-step">
      <bwc-select-your-job
        *ngSwitchCase="2"
        [itemClickable]="true"
        [prevBut]="true"
        [closeBut]="false"
        class="fixed-size"
      ></bwc-select-your-job>
    </div>
    <div class="animation-step">
      <bwc-desired-occupations
        *ngSwitchCase="3"
        [prevBut]="true"
        [closeBut]="false"
        class="fixed-size"
      ></bwc-desired-occupations>
    </div>
    <div class="animation-step">
      <bwc-cv-skills
        *ngSwitchCase="4"
        [prevBut]="true"
        [closeBut]="false"
        class="fixed-size"
      ></bwc-cv-skills>
    </div>
    <div class="animation-step">
      <bwc-profession-skills
        *ngSwitchCase="5"
        [mode]="'all'"
        [maxWorkProfessions]="2"
        [maxDreamProfessions]="2"
        [prevBut]="true"
        [closeBut]="false"
        class="fixed-size"
      ></bwc-profession-skills>
    </div>
    <div class="animation-step">
      <bwc-education-level-selection
        *ngSwitchCase="6"
        [prevBut]="true"
        [closeBut]="false"
        class="fixed-size"
      ></bwc-education-level-selection>
    </div>
    <div class="animation-step">
      <bwc-languages-knowledge
        *ngSwitchCase="7"
        [prevBut]="true"
        [closeBut]="false"
        class="fixed-size"
      ></bwc-languages-knowledge>
    </div>
  </ng-container>
</div>
